import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterEvent, RouterModule } from '@angular/router';
import { IUserData } from '@core/models/user.model';
import { StoreService } from '@core/store/store.service';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { HelperService } from '@shared/services/helper.service';
import { ToastModule } from 'primeng/toast';
import { filter } from 'rxjs/operators';
import { FacilityAccountChooserComponent } from '../facility-account-chooser/facility-account-chooser.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from '@shared/components/header/header.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { WCAGDummyLinkTargetDirective } from '@shared/directives/wcag-dummy-link-target.directive';

@Component({
  selector: 'app-app-wrapper',
  templateUrl: './app-wrapper.component.html',
  styleUrls: ['./app-wrapper.component.scss'],
  imports: [FooterComponent, ToastModule, RouterModule, FacilityAccountChooserComponent,
    NgbCollapseModule, HeaderComponent, CommonModule, TranslateModule, WCAGDummyLinkTargetDirective
  ]
})
export class AppWrapperComponent implements OnInit {
  isNavbarCollapsed = true;
  userData: IUserData;

  constructor(
    private store: StoreService,
    private helperService: HelperService,
    private router: Router,
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe((routeData: NavigationEnd) => {
      const activeMenuItemFound = this.setActiveMenuItem(routeData.url);

      if (!activeMenuItemFound && this.router.getCurrentNavigation().previousNavigation) {
        const previousUrl = this.router.getCurrentNavigation()
          .previousNavigation.finalUrl.toString();
        this.setActiveMenuItem(previousUrl);
      }

      setTimeout(() => {
        const mainEl = document.getElementById('main-content');
        if (mainEl) {
          const innerEl = mainEl.getElementsByClassName('inner')[0];
          if (innerEl) {
            innerEl.scrollTo(0, 0);
          }
        }
      });
    });
  }

  ngOnInit() {
    this.store.user$.subscribe(userData => {
      this.userData = userData;
      this.setActiveMenuItem(this.router.url);

      if(this.store.user.isOffset()){
        this.userData.menuItems.find( item => {
          if (item.name === 'MENU_PROGRAM_MANAGEMENT') {
            item.path = 'program-management/offsets-results'
          }
        });
      }
    });
  }

  getTranslatedPath(path) {
    return this.helperService.getTranslatedPath(path).join('/');
  }

  setActiveMenuItem(url) {
    let activeItemFound = false;

    if (this.userData) {
      url = this.helperService.getTranslatedPath(url.split('/')[2])[0];

      this.userData.menuItems.forEach(item => {
        const path = this.helperService
          .getTranslatedPath(item.path.split('/')[0])[0];
        var decodedStr = decodeURIComponent(url);
        item.isActive = path === url || path === decodedStr;
        if (!item.isActive && item.urlMappings) {
          item.isActive = item.urlMappings.includes(url);
        }

        if (item.isActive) {
          activeItemFound = true;
        }
      });
    }

    return activeItemFound;
  }
}
